module.exports = __webpack_public_path__ + "img/text01.ee419e95.png";